import React, { Component } from 'react';
import './flipCard.scss';

/** @import { FlipCardProps, FlipCardState } from './FlipCardTypes' */

export const FlipCardFront = (/** @type {{ children: React.ReactNode }} */ { children }) => (
  <div className="flip-card__front">
    {children}
  </div>
);
export const FlipCardBack = (/** @type {{ children: React.ReactNode }} */ { children }) => (
  <div className="flip-card__back">
    {children}
  </div>
);

/** @extends {Component<FlipCardProps, FlipCardState>} */
class FlipCard extends Component {
  state = { expectedFlipValue: null };

  /** @type {React.RefObject<HTMLDivElement>} */
  flipElement = React.createRef();

  componentDidMount() {
    this.updateHeight();
  }

  componentDidUpdate(/** @type {FlipCardProps} */ prevProps) {
    if (prevProps.flipped !== this.props.flipped) {
      this.onTransitionStart();
    }
    this.updateHeight();
  }

  updateHeight() {
      let height = 0;
      if (!this.flipElement.current) return;
      [...this.flipElement.current.children].forEach(child => {
          height = Math.max(height, child.clientHeight);
      });
      this.flipElement.current.style.height = `${height}px`;
  }

  onTransitionStart = () => {
    const { flipped, onBeforeFlip } = this.props;
    this.setState({ expectedFlipValue: flipped });
    if (typeof onBeforeFlip === 'function') onBeforeFlip(flipped);
  }

  onTransitionEnd = () => {
    const { flipped, onAfterFlip } = this.props;
    this.setState(({ expectedFlipValue }) => {
      if (expectedFlipValue === flipped) {
        if (typeof onAfterFlip === 'function') onAfterFlip(flipped);
      }
      return { expectedFlipValue: null };
    });
  }

  render() {
    const { children, flipped } = this.props;
    return (
      <div className={['flip-card', flipped ? 'flip-card--flipped' : ''].join(' ')} onTransitionEnd={this.onTransitionEnd} ref={this.flipElement}>
        {children}
      </div>
    );
  }
}

export default FlipCard;
